import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { NotificationResponse } from './models/notification-response.model';
import { NotificationModel } from './models/notification.model';


@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseGQLService<NotificationResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: NotificationModel,
        clientName: 'NotificationService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryNotificationBarContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


